import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { useAppSelector, useWindowDimensions } from 'redux/hooks';
import { exportRawData } from 'components/common/DataDownloader';
import moment from 'moment';
import api from 'utils/api';
import custom_palette from 'theme/custom_palettes';
import WaveLine from 'components/waveLine/WaveLine';
import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system/styleFunctionSx';

// =============================================================================
// 40: appbar, 94.5: appbar, 80: options, 400: chart
const VIEW_HEIGHT = window.innerHeight - 40 - 94.5 - 80 - 400;

// =============================================================================
const TITLES = ['CSV'];

// const BUTTON_MARGIN = 16;
const BUTTON_HEIGHT = 32;

const download_style: SxProps<Theme> = {
  backgroundColor: 'transparent',
  border: 2,
  borderColor: custom_palette.blue[800],
  color: custom_palette.blue[800]
};

// =============================================================================
type RawDataViewProps = {
  mobile?: boolean;
  disabled?: boolean;
};

export default function RawDataView({
  mobile = false,
  disabled = false
}: RawDataViewProps) {
  const { width } = useWindowDimensions();
  const graphController = useAppSelector((state) => state.graphController);
  const cardSet = useAppSelector((state) => state.datasetCardController.set);

  const handleDownload = async () => {
    const start = graphController.startTime;
    const end = graphController.endTime;
    cardSet.map(async (card: any) => {
      try {
        const res = await api.post('/api/rawData/download', {
          parameterId: card.id.toString(),
          from: start,
          to: end,
          depth: card.depth.value
        });
        exportRawData(
          `${res.data.fileName}_${moment().valueOf()}_${start}_${end}`,
          res.data.data,
          card.isCruiseParam,
          card.unit
        );
        alert('Successfully downloaded');
      } catch (err: any) {
        alert(err.response.data.message);
      }
    });
  };

  if (mobile) {
    return (
      <>
        {/** Transition */}
        <WaveLine style={{ fill: custom_palette.yellow[200] }} />

        {/** CSV download */}
        <div
          style={{
            padding: 32,
            backgroundColor: custom_palette.yellow[200],
            paddingBottom: 100,
            marginBottom: -100
          }}
        >
          <Typography
            variant='body_large_strong'
            color={custom_palette.blue[800]}
          >
            Raw Data
          </Typography>
          <Typography
            style={{ marginTop: 12 }}
            color={custom_palette.blue[800]}
          >
            Download
          </Typography>
          <Button
            variant='chip'
            onClick={handleDownload}
            sx={download_style}
            style={{
              marginTop: 12,
              height: BUTTON_HEIGHT * 1.5,
              borderRadius: BUTTON_HEIGHT,
              width: width / 4
            }}
            disabled={disabled}
          >
            CSV
          </Button>
          <Typography
            style={{ marginTop: 12 }}
            color={custom_palette.blue[800]}
          >
            This file contains raw data readings for the selected parameter,
            location, depth, and date range.
          </Typography>
        </div>
      </>
    );
  }

  return (
    <div style={{ margin: '0 48px', minHeight: VIEW_HEIGHT }}>
      <Divider />
      <div style={{ height: 40 }} />
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }} />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='overline' color='blue.900'>
            Download
          </Typography>
          <Button
            variant='secondary'
            color='dark'
            style={{ marginLeft: 8 }}
            onClick={handleDownload}
          >
            {TITLES[0]}
          </Button>
        </div>
      </div>
      <div style={{ height: 40 }} />
    </div>
  );
}
